import { ReactNode } from "react";

interface ButtonProps {
  children: ReactNode; // Button text or content
  size?: "sm" | "md"; // Button size
  variant?: "primary" | "outline"; // Button variant
  startIcon?: ReactNode; // Icon before the text
  endIcon?: ReactNode; // Icon after the text
  onClick?: () => void; // Click handler
  disabled?: boolean; // Disabled state
  className?: string; // Additional classes
  type?: "button" | "submit" | "reset"; // Button type for forms
}

const Button: React.FC<ButtonProps> = ({
  children,
  size = "md",
  variant = "primary",
  startIcon,
  endIcon,
  onClick,
  className = "",
  disabled = false,
  type = "button",
}) => {
  // Size Classes
  const sizeClasses = {
    sm: "px-4 py-2 text-sm",
    md: "px-5 py-2 text-sm",
  };

  // Variant Classes
  const variantClasses = {
    primary:
      "bg-teal-600 text-white shadow-theme-xs \
     hover:bg-teal-700 \
     dark:bg-teal-600 dark:hover:bg-teal-700 \
     disabled:bg-teal-300 dark:disabled:bg-teal-800",

    outline:
      "text-gray-600 dark:text-gray-400 border border-gray-300 dark:border-[#FFFFFF0F] \
     hover:bg-gray-50 dark:hover:bg-gray-950",
  };

  return (
    <button
      type={type}
      className={`inline-flex items-center justify-center gap-2 rounded-[6px] transition ${className} ${
        sizeClasses[size]
      } ${variantClasses[variant]} ${
        disabled ? "cursor-not-allowed opacity-50" : ""
      }`}
      onClick={onClick}
      disabled={disabled}
    >
      {startIcon && <span className="flex items-center">{startIcon}</span>}
      {children}
      {endIcon && <span className="flex items-center">{endIcon}</span>}
    </button>
  );
};

export default Button;
